import { useSyncExternalStore } from 'react';

/**
 * The open state of the command palette, outside React so that any component opens it: the
 * sidebar search field, the mobile search button, ⌘K and "/" (design navigation-v2 e 5d). The
 * app shell (`SMLContainer`) draws the one palette and reads this state.
 */
let isOpen = false;
const listeners = new Set<() => void>();

function emit(next: boolean): void {
  if (next === isOpen) {
    return;
  }
  isOpen = next;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot(): boolean {
  return isOpen;
}

export function openCommandPalette(): void {
  emit(true);
}

export function closeCommandPalette(): void {
  emit(false);
}

export function toggleCommandPalette(): void {
  emit(!isOpen);
}

/** True while the command palette is open. */
export function useIsCommandPaletteOpen(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
